import { render, staticRenderFns } from "./CardBill.vue?vue&type=template&id=39d9f521&scoped=true"
import script from "./CardBill.vue?vue&type=script&lang=js"
export * from "./CardBill.vue?vue&type=script&lang=js"
import style0 from "./CardBill.vue?vue&type=style&index=0&id=39d9f521&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d9f521",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VCardSubtitle,VCardTitle,VIcon})
